module.exports = __webpack_public_path__ + "img/2013_photo.ade81ecf.png";